<div class="container-header">
  <app-ion-common-header
    [id]="headerId"
    (backHeader)="backPage()"
    (focusHeader)="shownContent()"
    [title]="titlePage"
    start="{{startStage}}"
    end="{{endStage}}"
  ></app-ion-common-header>

  <ion-content
    [attr.aria-hidden]="ariaHidden"
    [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
    class="keyb-off"
  >
    <app-ion-common-label
      [id]="idLabelAdressCompleted"
      class="document-type-label1"
      labelStyle="display-rg"
      labelDescription="Complete seu endereço"
    >
    </app-ion-common-label>

    <div class="conent-center conent-center--mrt-lg">
      <form [formGroup]="addressNameForm" (ngSubmit)="submitForm($event)">
        <div class="ids-pb-4">
          <app-ion-common-input
            class="ids-py-3"
            [fieldValue]="name"
            [placeholder]="placeholder"
            [error]="error"
            [id]="idComponentName"
            [textError]="textError"
            maxLength="150"
            (click)="analyticsEventCliqueInput('Rua')"
            (textChange)="name=$event; setValueInput($event, 'nameAddress'); errorMessage();"
            type="text"
            [idLabel]="idLabel"
            [label]="label"
            [replaceStrTo]="'documentWithSpace'"
            [labelInput]="addressInitalPostCode?.street !== '' ? labelState : null"
            [disabled]="addressInitalPostCode?.street !== ''"
            name="nameAddress"
            labelInputText="true"
            formControlName="nameAddress"
            ngDefaultControl
          >
          </app-ion-common-input>
        </div>
        <div class="ids-pb-4">
          <app-ion-common-input
            [fieldValue]="number"
            [placeholder]="placeholderNumber"
            [error]="errorNumber"
            [id]="idComponentNumber"
            [textError]="textErrorNumber"
            maxLength="5"
            (click)="analyticsEventCliqueInput('Numero')"
            (textChange)="number=$event; setValueInput($event, 'numberAddress'); errorMessageNumber();"
            type="text"
            [idLabel]="idLabelNumber"
            [label]="labelNumber"
            [replaceStrTo]="'documentWithSpaceBar'"
            name="numberAddress"
            formControlName="numberAddress"
            labelInputText="true"
            ngDefaultControl
          >
          </app-ion-common-input>
        </div>
        <div class="ids-pb-4">
          <app-ion-common-input
            [fieldValue]="nameAdjunt"
            [placeholder]="placeholderAdjunt"
            [error]="errorAdjunt"
            [id]="idComponentAdjunt"
            [textError]="textErrorAdjunt"
            maxLength="20"
            (click)="analyticsEventCliqueInput('Complemento')"
            (textChange)="nameAdjunt=$event; setValueInput($event, 'adjuntAddress'); errorMessageAdjunt();"
            type="text"
            [idLabel]="idLabelAdjunt"
            [label]="labelAdjunt"
            [replaceStrTo]="'documentWithSpace'"
            name="adjuntAddress"
            formControlName="adjuntAddress"
            labelInputText="true"
            ngDefaultControl
          >
          </app-ion-common-input>
        </div>
        <div class="ids-pb-4">
          <app-ion-common-input
            [fieldValue]="districAddress"
            [placeholder]="placeholderDistrict"
            [error]="errorDistrict"
            [id]="idComponentDistrict"
            [textError]="textErrorDistrict"
            maxLength="60"
            (click)="analyticsEventCliqueInput('Bairro')"
            (textChange)="districAddress=$event; setValueInput($event, 'districtAddress'); errorMessageDistrict();"
            type="text"
            [idLabel]="idLabelDistrict"
            [label]="labelDistrict"
            [replaceStrTo]="'documentWithSpace'"
            [labelInput]="addressInitalPostCode?.district !== '' ? labelState : null"
            [disabled]="addressInitalPostCode?.district !== ''"
            name="districtAddress"
            formControlName="districtAddress"
            labelInputText="true"
            ngDefaultControl
          >
          </app-ion-common-input>
        </div>
        <div class="ids-pb-4">
          <app-ion-common-input
            [fieldValue]="nameState"
            [placeholder]="placeholderState"
            [error]="errorState"
            [id]="idComponentState"
            [textError]="textErrorState"
            maxLength="23"
            (textChange)="nameState=$event;"
            type="text"
            [idLabel]="idLabelState"
            [label]="labelState"
            [labelInput]="labelState"
            [disabled]="true"
            name="stateAddress"
            formControlName="stateAddress"
            [labelInputText]="true"
            ngDefaultControl
          >
          </app-ion-common-input>
        </div>
        <div class="ids-pb-4">
          <app-ion-common-input
            [fieldValue]="nameCity"
            [placeholder]="placeholderCity"
            [error]="errorCity"
            [id]="idComponentCity"
            [textError]="textErrorCity"
            maxLength="23"
            (textChange)="nameCity=$event;"
            type="text"
            [idLabel]="idLabelCity"
            [label]="labelCity"
            [labelInput]="labelInputCity"
            [disabled]="true"
            name="cityAddress"
            formControlName="cityAddress"
            [labelInputText]="true"
            ngDefaultControl
          >
          </app-ion-common-input>
        </div>
      </form>
    </div>
    <p class="text-rg text-pd">
      Ao continuar, declaro, sob minha responsabilidade e para fins de
      comprovação de residência, que resido no endereço acima.
    </p>
  </ion-content>
  <app-ion-common-button
    [id]="idButtonAdressCompleted"
    class="hidden"
    [positionButton]="'block'"
    [ngClass]="{'hidden': !buttonEnable || checkEmptyValue()}"
    [attr.aria-hidden]="!buttonEnable || checkEmptyValue()"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>
</div>
